import React from 'react';
import { Dropdown } from './Dropdown';

interface DropdownInterface {
  parallelUnits: number;
  setParallelUnits(val: number): void;
}

export const ParallelUnitsDropdown = ({
  parallelUnits,
  setParallelUnits,
}: DropdownInterface) => {
  const dropDownOptions = [
    { value: 1, name: 'Single unit' },
    { value: 2, name: 'Two units' },
    { value: 3, name: 'Three units' },
    { value: 4, name: 'Four units' },
    { value: 5, name: 'Five units' },
    { value: 6, name: 'Six units' },
    { value: 7, name: 'Seven units' },
    { value: 8, name: 'Eight units' },
    { value: 9, name: 'Nine units' },
    { value: 10, name: 'Ten units' },
    { value: 11, name: 'Eleven units' },
    { value: 12, name: 'Twelve units' },
  ];

  return (
    <Dropdown
      value={
        dropDownOptions.find((option) => option.value === parallelUnits)
          ?.name ?? ''
      }
      setValue={(val) => {
        const valAsNumber =
          dropDownOptions.find((option) => option.name === val)?.value ?? 1;
        setParallelUnits(valAsNumber);
      }}
      label={`Parallel units`}
      dropDownOptions={dropDownOptions.map((option) => option.name)}
    />
  );
};
